export const FETCH_POWER_USE_VS_GENERATION_REQUEST =
  '[PowerUseVsGeneration] FETCH_POWER_USE_VS_GENERATION_REQUEST';
export const FETCH_POWER_USE_VS_GENERATION_SUCCESS =
  '[PowerUseVsGeneration] FETCH_POWER_USE_VS_GENERATION_SUCCESS';
export const FETCH_POWER_USE_VS_GENERATION_FAILURE =
  '[PowerUseVsGeneration] FETCH_POWER_USE_VS_GENERATION_FAILURE';
